import ReactHtmlParser from 'react-html-parser';
import Rating from '../Rating';


const TextType = ({ content, mediaClass, rating, fontSize, lineCount, size }) => {
  return <div className={`position-relative overflow-hidden ${mediaClass}`} style={{paddingBottom:`${size ? size : '100'}%`}}>
            <div className="w-100 f-center flex-column position-absolute start-0 top-0 h-100 p-3">
              {rating ? 
              <div className="f-center ps-1 mb-4">
                <Rating className={'mx-1 fs-3'} iconClass="mx-1" rating={rating} />
              </div> 
              : null}
              <div className="overflow-hidden">
                <p className={`text-center line-clamp-${lineCount ? lineCount : 4} line-clamp mb-0 ${!fontSize ?'fs-7':''}`} style={{fontSize:fontSize}}>{ReactHtmlParser(content)}</p>
              </div>
            </div>
          </div>
}
export default TextType
